const numeral = require('numeral');



// Format as USD currency
// export const formattedAmount =(amount)=> numeral(amount).format('$0,0.00'); 
export const formattedAmount = (amount) => `₵${numeral(amount).format('0,0.00')}`;
 